import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	guestTel: string;
};

export const BasicInfoGuestTelOfPrintComposition = ({ guestTel }: Props) => {
	return <PrintBasicInfoTableLayout title="電話番号" content={guestTel} />;
};
